export default [
    {
        path: 'relatorio-acesso-funcionalidade',
        component: () => import(
            /* webpackChunkName: 'administracao-relatorio-acesso-funcionalidade' */
            '@/views/administracao/relatorio-acesso-funcionalidade/Index'
        ),
        redirect: 'relatorio-acesso-funcionalidade/index',
        children: [
            {
                name: 'administracao-relatorio-acesso-funcionalidade-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'administracao-relatorio-acesso-funcionalidade' */
                    '@/views/administracao/relatorio-acesso-funcionalidade/List.vue'
                ),
            },
        ],
    },
]